<template lang="pug">
  main.standard.resume
    section.about
      h1 Objectives
      p 
        | With over two decades of experience (since highschool) in web development with startup experience in The Silicon Valley, 
        | I'm interested in helping your business attract revenue, solve problems, and cultivate lasting relationships with your customers!
        | I'm particularly keen on helping you build your minimum viable product - 
        | either as a developer or by teaching you how to code it yourself
      
    section.xp
      h1 Experience
      vertical-timeline(
        :reversed='false'
        :input-data='timeline'
      )
</template>

<script>

  export default {
    name: 'standard.resume.main',

    data() {
      return {
        timeline: [
          {
            _id: "5d820c33647310e4a4f9845c",
            title: 'JAMstack',
            text: '',
            date: '2016 - Present',
            tags: [
              'VueJS',
              'Firebase',
              'APIs',
              'PWA',
              'ES6, ES7, ES8+',
              'Git',
              'Jest',
              'Puppeteer'
            ]
          },
          {
            _id: "5d820c335861d73a733a458f",
            title: "MeteorJS",
            text: '',
            date: '2015 - 2016',
            tags: [
              // "quis",
              // "aliqua"
            ]
          },
          {
            _id: "5d820c335861d73a733a458f",
            title: 'MEANstack',
            text: '',
            date: '2012 - 2015',
            tags: [
              'MongoDB',
              'jQuery',
              'NodeJS',
              'ExpressJS'
            ]
          },
          {
            _id: "5d820c335861d73a733a458f",
            title: 'Ruby on Rails',
            text: '',
            date: '2004 - 2012',
            tags: [
              "jQuery",
              "Ruby",
              'MySQL',
              'CoffeeScript',
              'Git',
              'Selenium',
              'Agile Dev',
              'Apache',
              'Ubuntu'
            ]
          },
          {
            _id: "5d820c335861d73a733a458f",
            title: 'LAMPstack',
            text: '',
            date: '2000 - 2004',
            tags: [
              'PHP',
              'MySQL',
              'Apache',
              'Debian',
              'Ubuntu',
              'Flash',
              'ActionScript'
            ]
          },

          {
            _id: "5d820c335861d73a733a458f",
            title: 'HTML/CSS Static',
            text: '',
            date: '1996 - 2000',
            tags: [
              // "quis",
              // "aliqua"
            ]
          },
        ]
      }
    }
  }
</script>

<style lang="stylus" scoped>
  p
    margin 1em 0

  section
    padding 3.6vh 3.6vw
    @media( max-width: 480px )
      padding 3.6vh 4.2vw 3.6vh 8vw
  
  h1
    font-size 1.75em
    line-height 1.5
    margin 1em 0

  main
    --orange rgb( 162 124 96 )
    --blue rgb( 100 192 225 )
    --white rgb( 216 216 216 )
    --black rgb( 64 64 64 )
    --gray rgb( 188 188 188 )

    background repeating-linear-gradient(
      45deg,
      var( --white ),
      var( --white ) 1px,
      rgb( 224 224 224 ) 1px,
      rgb( 224 224 224 ) 2px
    )
    line-height 1.75
    font-size 1.1em
    color var( --black )
    text-shadow 0 1px 0 rgba( 255 255 255 .5 )
    

    >>> .timeline
      &::after
        background var( --gray )
      .content__date
        margin 12px 0
      .content__tag
        background rgba( 160 160 160 .1 )
        color inherit
        font-size .88em
        border-radius 3px
        padding 2px 12px
        display inline-block
        margin 4px

    >>> .timeline__item
      font-size .8em
      background 0
      padding 0
      .content
        padding 32px
        margin 16px 0
        background rgb( 224 224 224 )
        background repeating-linear-gradient(
      45deg,
        rgb( 224 224 224 ),
        rgb( 224 224 224 ) 1px,
        rgb( 228 228 228 ) 1px,
        rgb( 228 228 228 ) 2px
      )
        box-shadow 0 0 16px rgba( 128 128 128 .1 )
        .content__heading
          color inherit
          font-size 1.25em
          margin-bottom 8px

      &:nth-child(odd)::before, &:nth-child(even)::before
        z-index 0
        background-color var( --gray )
      
      &:nth-child(odd), &:nth-child(even)
        .content::before
          border-color var( --gray )
          background-color var( --gray )

      &::after
        background var( --white )
        border-color var( --gray )
</style>